<div class="col-12">
  <form [formGroup]="entidadeEnvolvidaForm" id="entidadeEnvolvidaForm">
    <div class="row g-4 mb-2">
      <div class="col-sm-12 form-group">
        <label nz-checkbox formControlName="deveNotificar">Exige Notificação</label>
      </div>

      <ng-container [ngSwitch]="tipoEntidadesEnvolvidasSelecionada">
        <ng-container *ngSwitchCase="tipoEntidadesEnvolvidasEnum.Unica">
          <div class="col-sm-4 form-group" *ngIf="!visualizar || !editar">
            <label for="entidade" class="form-label" [class.required]="isRequired('entidade')">Entidade que sofreu a
              mudança</label>
            <nz-select formControlName="entidade" nzShowSearch nzAllowClear nzPlaceHolder="-" nzSize="large"
              [compareWith]="compareFn">
              <nz-option [nzValue]="item" [nzLabel]="item.nomeFantasia" *ngFor="let item of entidadesLista" />
            </nz-select>
          </div>

          <div class="col-sm-4 form-group">
            <label for="novaRazaoSocial" class="form-label">Razão Social</label>
            <nz-input-group nzSize="large">
              <input nz-input id="novaRazaoSocial" formControlName="novaRazaoSocial" [disabled]="false" />
            </nz-input-group>
          </div>

          <ng-container *ngIf="mostrarRazaoSocial">
            <div class="col-sm-4 form-group">
              <label for="razaoSocialAnterior" class="form-label" [class.required]="isRequired('novaRazaoSocial')">Razão
                Social Anterior</label>
              <nz-input-group nzSize="large">
                <input nz-input id="razaoSocialAnterior" formControlName="razaoSocialAnterior" />
              </nz-input-group>
            </div>
          </ng-container>

        </ng-container>

        <ng-container *ngSwitchCase="tipoEntidadesEnvolvidasEnum.Varias">
          <div class="col-4 form-group">
            <label for="entidade" class="form-label" [class.required]="isRequired('entidade')">Entidade que participou
              da mudança</label>
            <nz-select formControlName="entidade" nzShowSearch nzAllowClear nzPlaceHolder="-" nzSize="large"
              [compareWith]="compareFn">
              <nz-option [nzValue]="item" [nzLabel]="item.nomeFantasia" *ngFor="let item of entidadesLista" />
            </nz-select>
          </div>

          <div class="col-4 form-group">
            <label for="tipoEnvolvimento" class="form-label" [class.required]="isRequired('tipoEnvolvimento')">Tipo de
              envolvimento</label>
            <nz-select formControlName="tipoEnvolvimento" nzShowSearch nzAllowClear nzPlaceHolder="-" nzSize="large"
              [compareWith]="compareFn">
              <nz-option [nzValue]="item" [nzLabel]="item.nomeTipoEnvolvimento"
                *ngFor="let item of tipoEnvolvimentoLista" />
            </nz-select>
          </div>
        </ng-container>
        <div class="col-sm-4 form-group">
          <label for="novoStatusEntidade" class="form-label"
            [class.required]="isRequired('novoStatusEntidade')">Situação da Entidade, Após a mudança</label>
          <nz-select formControlName="novoStatusEntidade" nzShowSearch nzAllowClear nzPlaceHolder="-" nzSize="large"
            [compareWith]="compareFn">
            <nz-option [nzValue]="item" [nzLabel]="item.nomeStatusEntidade" *ngFor="let item of statusEntidadeList" />
          </nz-select>
        </div>
      </ng-container>

      <ng-container *ngIf="deveNotificar">
        <div class="col-sm-12 form-group">
          <label for="emails" class="form-label">E-mails</label>
          <app-email-search-select formControlName="emails" [multiple]="true"
            placeholder="Digite ao menos 3 letras do e-mail"></app-email-search-select>
        </div>
      </ng-container>
    </div>
  </form>
</div>
